import Vue from 'vue';

export default {
  setIntroState(state, { collapsed }) {
    Vue.set(state, 'collapsed', collapsed);
  }
};
